module.exports = __webpack_public_path__ + "img/Frame4.b4f67370.png";